import oget from 'oget';
import keyBy from 'lodash.keyby';
import { SUCCESS, ERROR } from '~/store/middleware/promise';
import getRoundCategoriesFromContest from '../../utils/getRoundCategoriesFromContest';

export const CONTESTS_SHOW = 'CONTESTS_SHOW';
export const CONTESTS_SHOW_SUCCESS = `${CONTESTS_SHOW}_${SUCCESS}`;
export const CONTESTS_SHOW_ERROR = `${CONTESTS_SHOW}_${ERROR}`;

const isUnset = (id) => id === undefined || id === null;

export const contestsShow = ({
  error,
  contests,
  contestsByExternalId,
  selectedContestId,
  selectedRoundId,
  selectedHeatId,
  forceRoundUpdate,
}) => {
  const payload = (async () => {
    if (error) {
      throw error;
    }

    if (isUnset(selectedContestId)) {
      return {
        contests,
        selectedHeatId,
        heatsById: {},
        selectedContest: {},
        selectedRound: {},
      };
    }

    const selectedContest = isUnset(selectedContestId)
      ? oget(contests, '0', {})
      : oget(contestsByExternalId, selectedContestId, {});
    const roundsByExternalId = keyBy(oget(selectedContest, 'rounds', []), 'externalId');

    const selectedRound = isUnset(selectedRoundId)
      ? oget(selectedContest, 'rounds[0]', {})
      : oget(roundsByExternalId, selectedRoundId, {});

    let selectedRoundCategories;
    if (selectedContest && selectedRound) {
      selectedRoundCategories = getRoundCategoriesFromContest(selectedContest, selectedRound.name);
    }

    return {
      contests,
      selectedHeatId,
      heatsById: keyBy(oget(selectedRound, 'heats'), 'externalId'),
      selectedContest,
      selectedRound,
      selectedRoundCategories,
      forceRoundUpdate,
    };
  })();

  return {
    type: CONTESTS_SHOW,
    payload,
  };
};
